/* styleWrappers-compiled.tsx generated by @compiled/babel-plugin v0.36.1 */
import _defineProperty from "@babel/runtime/helpers/defineProperty";
import _extends from "@babel/runtime/helpers/extends";
import "./styleWrappers-compiled.compiled.css";
import * as React from 'react';
import { ax, ix } from "@compiled/react/runtime";
function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
/* eslint-disable @atlaskit/design-system/use-tokens-typography */

import { forwardRef, useMemo } from 'react';
import { TouchScrollable } from 'react-scrolllock';
import { useMergeRefs } from 'use-callback-ref';
import { Box, xcss } from '@atlaskit/primitives';
import Heading from '@atlaskit/heading';
var blanketStyles = null;
var headerWrapperStyles = null;
var archiveHeaderWrapperStyles = null;
var listWrapperStyles = null;
var closeButtonWrapperStyles = null;
var contentWrapperStyles = null;
var contentWrapperStyleWithSideBar = null;
var zoomWrapperStyles = null;
var zoomCenterControlsStyles = null;
var zoomRightControlsStyles = null;
var zoomLevelIndicatorStyles = null;
var hdIconGroupWrapperStyles = null;
var errorMessageWrapperStyles = null;
var errorImageStyles = null;
var videoStyles = null;
var pdfWrapperStyles = null;
var arrowStyles = null;
var arrowWrapperStyles = null;
var arrowsWrapperStyles = null;
var leftWrapperStyles = null;
var leftWrapperStylesWithSideBar = null;
var rightWrapperStyles = null;
var headerStyles = null;
var headerStyleWithSideBar = null;
var leftHeaderStyles = null;
var imageWrapperStyles = null;
var baselineExtendStyles = null;
var imgStyles = null;
var pixelatedImgStyles = null;
var medatadataTextWrapperStyles = null;
var metadataWrapperStyles = null;
var metadataFileNameStyles = null;
var metadataSubTextStyles = null;
var metadataIconWrapperStyles = xcss({
  paddingTop: 'space.050',
  paddingRight: 'space.150'
});
var rightHeaderStyles = null;
var customAudioPlayerWrapperStyles = null;
var audioPlayerStyles = null;
var audioStyles = null;
var audioCoverStyles = null;
var defaultCoverWrapperStyles = null;
var downloadButtonWrapperStyles = null;
var customVideoPlayerWrapperStyles = null;
var sidebarWrapperStyles = null;
var spinnerWrapperStyles = null;
var formattedMessageWrapperStyles = null;
// We are keeping this data-testid since JIRA is still using it in their codebase to perform checks. Before removing this, we need to ensure this 'media-viewer-popup' test id is not being used anywhere else in other codebases
export var Blanket = function Blanket(_ref) {
  var datatestId = _ref['data-testid'],
    className = _ref.className,
    children = _ref.children;
  return /*#__PURE__*/React.createElement("div", {
    "data-testid": datatestId,
    className: ax(["_kqsw1n9t _154iidpf _1ltvidpf _94n5idpf _1xi2idpf _bfhk1tzm _1pby1qpw _1e0c1txw", className])
  }, children);
};
export var HeaderWrapper = function HeaderWrapper(_ref2) {
  var className = _ref2.className,
    children = _ref2.children,
    isArchiveSideBarVisible = _ref2.isArchiveSideBarVisible;
  return /*#__PURE__*/React.createElement("div", {
    // eslint-disable-next-line @atlaskit/ui-styling-standard/no-classname-prop -- Ignored via go/DSP-18766
    className: ax(["_11q75a80 _kqswstnw _154iidpf _1ltvidpf _1bsb1osq _4t3i1uc6 _tzy41w01 _ouxlidpf _syaz1poe _k48p1wq8 _ca0q1ejb _n3td1ejb _19bv1ejb _u5f31ejb _vchhusvi _lcxvglyw _1pby3tda", isArchiveSideBarVisible && "_ouxl1klg", className])
  }, children);
};
HeaderWrapper.displayName = 'HeaderWrapper';
export var ListWrapper = function ListWrapper(_ref3) {
  var children = _ref3.children;
  return /*#__PURE__*/React.createElement("div", {
    className: ax(["_1bsb1osq _4t3i1osq _kqswh2mm _1e0c1txw _4cvr1h6o _1bah1h6o"])
  }, children);
};
ListWrapper.displayName = 'ListWrapper';
export var ArrowsWrapper = function ArrowsWrapper(_ref4) {
  var children = _ref4.children;
  return /*#__PURE__*/React.createElement("div", {
    id: "media-viewer-navigation",
    className: ax(["_1e0c1txw _kqswstnw _154i1ssb _t9ec1i34 _1ltvidpf _1bsb1osq"])
  }, children);
};
export var CloseButtonWrapper = function CloseButtonWrapper(_ref5) {
  var className = _ref5.className,
    children = _ref5.children;
  return /*#__PURE__*/React.createElement("div", {
    className: ax(["_kqswstnw _154i1ejb _1xi2v47k _1pbyuou7", className])
  }, children);
};
export var ContentWrapper = function ContentWrapper(_ref6) {
  var isSidebarVisible = _ref6.isSidebarVisible,
    children = _ref6.children;
  return /*#__PURE__*/React.createElement("div", {
    className: ax(["_1bsb1osq", isSidebarVisible && "_1bsbyazj"])
  }, children);
};
export var ZoomWrapper = function ZoomWrapper(_ref7) {
  var className = _ref7.className,
    children = _ref7.children;
  return /*#__PURE__*/React.createElement("div", {
    className: ax(["_1bsb1osq _kqswstnw _94n5idpf _4t3i1uc6 _1itkdlpg _tzy41w01 _lcxvglyw _vchhusvi _1e0c1txw _4cvresu3 _ca0qthnh _n3td1yov _u5f31ejb _19bv1ejb", className]),
    style: {
      "--_iop1ex": ix("var(--ds-space-100, 10px)".concat(" ", "var(--ds-space-300, 24px)"))
    }
  }, children);
};
export var ZoomCenterControls = function ZoomCenterControls(_ref8) {
  var children = _ref8.children;
  return /*#__PURE__*/React.createElement("div", {
    className: ax(["_zulp1yov _1bsb1osq _1e0c1txw _1bah1h6o _1vgl1rj4"])
  }, children);
};
export var ZoomRightControls = function ZoomRightControls(_ref9) {
  var children = _ref9.children;
  return /*#__PURE__*/React.createElement("div", {
    className: ax(["_zulp1yov _kqswstnw _1xi21ejb _syaz1poe _lcxv1rj4 _1e0c1txw _1bahusic"])
  }, children);
};
export var ZoomLevelIndicator = function ZoomLevelIndicator(_ref10) {
  var children = _ref10.children;
  return /*#__PURE__*/React.createElement("span", {
    "data-testid": "zoom-level-indicator",
    className: ax(["_vwz4zwfg _4t3izwfg _s7n4nkob"])
  }, children);
};
export var HDIconGroupWrapper = function HDIconGroupWrapper(_ref11) {
  var className = _ref11.className,
    children = _ref11.children;
  return /*#__PURE__*/React.createElement("div", {
    className: ax(["_zulp1yov _1e0c1txw _4cvr1h6o _kqswh2mm _1bsb1tcg _19kzstnw", className])
  }, children);
};
export var ErrorMessageWrapper = function ErrorMessageWrapper(_ref12) {
  var datatestId = _ref12['data-testid'],
    children = _ref12.children;
  return /*#__PURE__*/React.createElement("div", {
    "data-testid": datatestId,
    className: ax(["_y3gn1h6o _syaz1poe _zcqx1osq"])
  }, children);
};
export var ErrorImage = function ErrorImage(_ref13) {
  var src = _ref13.src,
    alt = _ref13.alt;
  return /*#__PURE__*/React.createElement("img", {
    alt: alt,
    src: src,
    className: ax(["_otyr1yov _uiztglyw"])
  });
};
export var Video = function Video(_ref14) {
  var autoPlay = _ref14.autoPlay,
    controls = _ref14.controls,
    src = _ref14.src;
  return /*#__PURE__*/React.createElement("video", {
    autoPlay: autoPlay,
    controls: controls,
    src: src,
    className: ax(["_1bsbauwl _4t3i1kxc"])
  });
};
var PDFWrapperBody = /*#__PURE__*/forwardRef(function (_ref15, ref) {
  var innerRef = _ref15.innerRef,
    datatestId = _ref15['data-testid'],
    children = _ref15.children;
  var bodyRef = useMergeRefs([ref, innerRef]);
  return /*#__PURE__*/React.createElement("div", {
    ref: bodyRef,
    "data-testid": datatestId,
    className: ax(["_1reo1wug _18m91wug _kqswstnw _154iidpf _1ltvidpf _94n5idpf _1xi2idpf _1l1f1n9t"])
  }, children);
});
export var PDFWrapper = /*#__PURE__*/forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(TouchScrollable, null, /*#__PURE__*/React.createElement(PDFWrapperBody, _extends({
    innerRef: ref
  }, props)));
});
export var Arrow = function Arrow(_ref16) {
  var className = _ref16.className,
    children = _ref16.children;
  return /*#__PURE__*/React.createElement("span", {
    className: ax(["_80omtlke _11pt15ty _di7o9txx _20ka1poe", className])
  }, children);
};
export var LeftWrapper = function LeftWrapper(_ref17) {
  var children = _ref17.children,
    isArchiveSideBarVisible = _ref17.isArchiveSideBarVisible;
  return /*#__PURE__*/React.createElement("div", {
    className: ax(["_kqswstnw _154i1ssb _t9ec1i34 _ca0qv47k _n3tdv47k _19bvv47k _u5f3v47k", "_y3gn1e5h _1ltvidpf", isArchiveSideBarVisible && "_1ltv1mjv"])
  }, children);
};
export var RightWrapper = function RightWrapper(_ref18) {
  var children = _ref18.children;
  return /*#__PURE__*/React.createElement("div", {
    className: ax(["_kqswstnw _154i1ssb _t9ec1i34 _ca0qv47k _n3tdv47k _19bvv47k _u5f3v47k", "_y3gnusic _1xi2idpf"])
  }, children);
};

// header.tsx

export var Header = function Header(_ref19) {
  var children = _ref19.children,
    isArchiveSideBarVisible = _ref19.isArchiveSideBarVisible,
    className = _ref19.className;
  return /*#__PURE__*/React.createElement("div", {
    // eslint-disable-next-line @atlaskit/ui-styling-standard/no-classname-prop
    className: ax(["_1e0c1txw _19bvidpf", isArchiveSideBarVisible && "_19bv1mjv", className])
  }, children);
};
export var LeftHeader = function LeftHeader(_ref20) {
  var children = _ref20.children;
  return /*#__PURE__*/React.createElement("div", {
    className: ax(["_16jlkb7n _1o9zkb7n _i0dlf1ug _1reo15vq _18m915vq _1vgl1rj4"])
  }, children);
};
export var ImageWrapper = /*#__PURE__*/forwardRef(function (_ref21, ref) {
  var children = _ref21.children,
    datatestId = _ref21['data-testid'],
    onClick = _ref21.onClick,
    style = _ref21.style,
    className = _ref21.className;
  return /*#__PURE__*/React.createElement("div", {
    "data-testid": datatestId,
    onClick: onClick,
    ref: ref,
    // eslint-disable-next-line @atlaskit/ui-styling-standard/enforce-style-prop -- Ignored via go/DSP-18766
    style: style
    // eslint-disable-next-line @atlaskit/ui-styling-standard/no-classname-prop -- Ignored via go/DSP-18766
    ,
    className: ax(["_1reo1wug _18m91wug _1bsbauwl _4t3i1kxc _y3gn1h6o _s7n4nkob _o5721q9c", className])
  }, children);
});
export var BaselineExtend = function BaselineExtend() {
  return /*#__PURE__*/React.createElement("div", {
    className: ax(["_4t3i1osq _1e0c1o8l _s7n4nkob"])
  });
};
export var Img = function Img(_ref22) {
  var canDrag = _ref22.canDrag,
    isDragging = _ref22.isDragging,
    shouldPixelate = _ref22.shouldPixelate,
    datatestId = _ref22['data-testid'],
    src = _ref22.src,
    style = _ref22.style,
    onLoad = _ref22.onLoad,
    onError = _ref22.onError,
    onMouseDown = _ref22.onMouseDown,
    alt = _ref22.alt,
    className = _ref22.className;
  var cursor = useMemo(function () {
    if (canDrag && isDragging) {
      return 'grabbing';
    } else if (canDrag) {
      return 'grab';
    } else {
      return 'auto';
    }
  }, [canDrag, isDragging]);
  return /*#__PURE__*/React.createElement("img", {
    // eslint-disable-next-line @atlaskit/ui-styling-standard/no-classname-prop -- Ignored via go/DSP-18766
    className: ax(["_1e0c1o8l _s7n4nkob _kqswh2mm", shouldPixelate && "_1kemd8h4", className]),
    alt: alt,
    "data-testid": datatestId,
    src: src
    // eslint-disable-next-line @atlaskit/ui-styling-standard/enforce-style-prop -- Ignored via go/DSP-18766
    ,
    style: _objectSpread({
      cursor: cursor
    }, style),
    onLoad: onLoad,
    onError: onError,
    onMouseDown: onMouseDown
  });
};
export var MedatadataTextWrapper = function MedatadataTextWrapper(_ref23) {
  var children = _ref23.children;
  return /*#__PURE__*/React.createElement("div", {
    className: ax(["_1reo15vq _18m915vq"])
  }, children);
};
export var MetadataWrapper = function MetadataWrapper(_ref24) {
  var children = _ref24.children;
  return /*#__PURE__*/React.createElement("div", {
    className: ax(["_1e0c1txw"])
  }, children);
};
export var MetadataFileName = function MetadataFileName(_ref25) {
  var datatestId = _ref25['data-testid'],
    children = _ref25.children;
  return /*#__PURE__*/React.createElement("div", {
    className: ax(["_1pnf15vq _1kvn15vq _12nx2smr _1e8s1osq _kmu51l2s _7csf1q9c _1twl1wq8 _1nda1poe"])
  }, /*#__PURE__*/React.createElement(Heading, {
    as: "h1",
    size: "medium",
    testId: datatestId
  }, children));
};
export var MetadataSubText = function MetadataSubText(_ref26) {
  var datatestId = _ref26['data-testid'],
    children = _ref26.children;
  return /*#__PURE__*/React.createElement("div", {
    "data-testid": datatestId,
    className: ax(["_1reo15vq _18m915vq _p12f1osq _1bto1l2s _o5721q9c _syaz1poe"])
  }, children);
};
export var MetadataIconWrapper = function MetadataIconWrapper(_ref27) {
  var children = _ref27.children;
  return /*#__PURE__*/React.createElement(Box, {
    xcss: metadataIconWrapperStyles
  }, children);
};
export var RightHeader = function RightHeader(_ref28) {
  var children = _ref28.children;
  return /*#__PURE__*/React.createElement("div", {
    className: ax(["_y3gnusic _2hwx1jfw _1ul9uuw1 _1vgl1rj4"])
  }, children);
};
export var CustomAudioPlayerWrapper = function CustomAudioPlayerWrapper(_ref29) {
  var children = _ref29.children;
  return /*#__PURE__*/React.createElement("div", {
    className: ax(["_kqswstnw _94n5idpf _1ltvidpf _1bsb1osq"])
  }, children);
};
export var AudioPlayer = function AudioPlayer(_ref30) {
  var datatestId = _ref30['data-testid'],
    children = _ref30.children;
  return /*#__PURE__*/React.createElement("div", {
    "data-testid": datatestId,
    className: ax(["_2rko1l7b _1reo15vq _18m915vq _bfhk1tzm _4cvr1h6o _1bah1h6o _1bsb1kdj _4t3i1kdj _1e0c1txw _2lx21bp4 _kqswh2mm"])
  }, children);
};
AudioPlayer.displayName = 'AudioPlayer';
export var Audio = /*#__PURE__*/forwardRef(function (_ref31, ref) {
  var autoPlay = _ref31.autoPlay,
    controls = _ref31.controls,
    src = _ref31.src,
    preload = _ref31.preload;
  return /*#__PURE__*/React.createElement("audio", {
    ref: ref,
    autoPlay: autoPlay,
    controls: controls,
    src: src,
    preload: preload,
    className: ax(["_1bsb1osq _kqswstnw _94n5idpf _1ltvidpf"])
  });
});
export var AudioCover = function AudioCover(_ref32) {
  var src = _ref32.src,
    alt = _ref32.alt;
  return /*#__PURE__*/React.createElement("img", {
    alt: alt,
    src: src,
    className: ax(["_1bsb1osq _4t3i1osq _5ralzm06 _bfhkr3uz"])
  });
};
export var DefaultCoverWrapper = function DefaultCoverWrapper(_ref33) {
  var children = _ref33.children;
  return /*#__PURE__*/React.createElement("div", {
    className: ax(["_1bsb1osq _4t3i1osq _1e0c1txw _4cvr1h6o _1bah1h6o _syaz1rlb _umc418ws"])
  }, children);
};
export var DownloadButtonWrapper = function DownloadButtonWrapper(_ref34) {
  var children = _ref34.children;
  return /*#__PURE__*/React.createElement("div", {
    className: ax(["_19pk1cfm _y3gn1h6o _1sfy1fjg _4pkp1fjg"])
  }, children);
};
export var CustomVideoPlayerWrapper = function CustomVideoPlayerWrapper(_ref35) {
  var datatestId = _ref35['data-testid'],
    children = _ref35.children;
  return /*#__PURE__*/React.createElement("div", {
    "data-testid": datatestId,
    className: ax(["_1p6zkb7n _1vnlkb7n _qbrxf1ug _1y2kauwl _z18o1kxc _1ghp1kxc"])
  }, children);
};
export var SidebarWrapper = function SidebarWrapper(_ref36) {
  var datatestId = _ref36['data-testid'],
    children = _ref36.children;
  return /*#__PURE__*/React.createElement("div", {
    "data-testid": datatestId,
    className: ax(["_1reo15vq _18m91wug _154iidpf _1xi2idpf _1bsb1ber _4t3i1kxc _bfhky0hh _syaz1vvf"])
  }, children);
};
export var SpinnerWrapper = function SpinnerWrapper(_ref37) {
  var children = _ref37.children;
  return /*#__PURE__*/React.createElement("div", {
    className: ax(["_1e0c1txw _1bah1h6o _4cvr1h6o _4t3i1osq"])
  }, children);
};
export var FormattedMessageWrapper = function FormattedMessageWrapper(_ref38) {
  var children = _ref38.children;
  return /*#__PURE__*/React.createElement("span", null, children);
};